import { useEffect, useState } from 'react';
import { GtmService } from '@mdc/services';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';

const InternalLink = ({ url, text, stateObj }) => {
    const [internalUrl, setInternealUrl] = useState(url);
    const [stateObject, setStateObject] = useState('');

    useEffect(() => {
        setInternealUrl(url);
        stateObj && setStateObject(stateObj);
    }, [url, stateObj]);

    return (
        <Link
            to={internalUrl}
            onClick={() => GtmService.handleNavigation(internalUrl)}
            state={stateObject}
        >
            {text}
        </Link>
    );
};

InternalLink.propTypes = {
    url: PropTypes.any,
    text: PropTypes.string,
    stateObj: PropTypes.obj
};

export default InternalLink;
